import { RouteConfig } from 'vue-router'
import { contactRouteNames } from '../constants/location'
import { requireAuthAndLocation } from '../auth'
import store from '../../store'
import { Utils } from '../../util/utils'
import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { Modules } from '../../util/modules'

// Import our custom Contact SmartList component
const ContactSmartList = () =>
  import(/* webpackChunkName: "contact-smartlist" */ '../../pmd/pages/smartlist/ContactSmartList.vue').then(m => m.default)

const BulkActionsContactsPage = () =>
  import(/* webpackChunkName: "customer-imports" */ '../../pmd/pages/bulk-actions/BulkActionsContactsPageInternalTools.vue').then(
    m => m.default
  )

const ContactDetails = () =>
  import(/* webpackChunkName: "contact-details" */ '../../pmd/pages/customers/CustomContactDetailNew.vue').then(m => m.default)


const CustomBulkActionsImportPage = () => import('@/pmd/pages/bulk-actions/CustomBulkActions.vue').then(m => m.default)


// Custom route guard to check if the user's company ID matches the required ID
const requireSpecificCompany = (to, from, next) => {
  // First run the standard auth and location check
  requireAuthAndLocation(to, from, (nextRoute) => {
    // If the standard check redirects somewhere else, respect that decision
    if (nextRoute && nextRoute !== to) {
      return next(nextRoute)
    }
    
    // Use our utility function to check if this is the special company
    if (Utils.isSpecialCompany()) {
      // Company ID matches, allow access
      return next()
    } else {
      // Company ID doesn't match, redirect to dashboard
      return next({ 
        name: 'dashboard-v2',
        params: to.params,
        query: to.query,
        replace: true 
      })
    }
  })
}

export const contactRoutes: RouteConfig[] = [
  {
    path: 'contact',
    name: contactRouteNames.default,
    component: EmptyRouterParent,
    children: [
      {
        path: 'smart_list/:smart_list',
        name: contactRouteNames.smartList,
        component: ContactSmartList,
        beforeEnter: requireSpecificCompany,
        meta: { 
          translations: [Modules.SmartList, Modules.ContactDetail, Modules.BulkActions],
          // Add a custom flag to identify this as the Contact version
          isContactSection: true
        },
      },
      {
        path: 'detail/:contact_id',
        name: contactRouteNames.specialCompanyDetail,
        component: ContactDetails,
        beforeEnter: requireSpecificCompany,
      },
      {
        path: 'import',
        name: contactRouteNames.import,
        component: CustomBulkActionsImportPage,
        beforeEnter: requireSpecificCompany,
      },
      {
        path: 'bulk',
        component: EmptyRouterParent,
        children: [
          {
            path: 'actions',
            name: contactRouteNames.bulkActions,
            component: BulkActionsContactsPage,
            beforeEnter: requireSpecificCompany,
            meta: { 
              translations: [Modules.BulkActions],
              // Add a custom flag to identify this as the Contact version
              isContactSection: true
            },
          },
        ],
      },
    ],
  },
] 